import styled from "styled-components";

export const Wrapper = styled.div`
  padding:10px 16px ;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;
  position: relative;

  @media (min-width: 768px){
    padding: 32px 64px;
   }

  @media (min-width: 1440px) {
    padding: 48px 120px;
  }
  
  h3{
    font-weight: 700;
    font-style: Bold;
    font-size: 20px;
    line-height: 28px;
    letter-spacing: 1px;
    text-align: center;

    @media (min-width: 850px){
      font-size: 40px;
      line-height: 48px;
      letter-spacing: 2px;
    }
  }

  .cell {
    position:relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    /* ▼ animação de entrada (adicionado) */
    opacity: 0;
    transform: translateY(10px);
    transition: opacity .45s ease, transform .45s ease;
    will-change: opacity, transform;
  }

  /* ▼ quando ativa, aplica o fade-up (adicionado) */
  .cell.in {
    opacity: 1;
    transform: translateY(0);
  }

  .value {
    font-weight: 600;
    font-style: bold;
    font-size: 40px;
    line-height: 48px;
    letter-spacing: 2px;

    @media (min-width: 850px){
      font-size: 56px;
      line-height: 64px;
    }
  }

  .label {
    font-weight: 400;
    font-style: regular;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0px;
    max-width: 150px;
    text-transform: capitalize;
  }

  .divider {
    position:absolute;
    right:-15%;
    top:50%;
    transform:translateY(-50%);
    width:1px;
    height:100%;
    background: rgba(255,255,255,.15);
    background-color:var(--color-e2ecff)
  }

  @media (max-width: 1200px){
    .divider {
      display:none;
    }
  }

  /* ▼ acessibilidade (adicionado) */
  @media (prefers-reduced-motion: reduce){
    .cell { transition: none; opacity: 1; transform: none; }
  }
`;

export const StatisBox = styled.div`
  display:grid;
  grid-template-columns: repeat(4,1fr);
  gap: 64px;
  max-width: 1100px;
  margin: 0 auto;

  @media (max-width: 1200px){
    grid-template-columns: 1fr 1fr;
    row-gap:16px;
    gap: 32px;
  }
`;
